import { render } from "./submenu.vue?vue&type=template&id=7abe757e"
import script from "./submenu.vue?vue&type=script&lang=js"
export * from "./submenu.vue?vue&type=script&lang=js"
script.render = render

export default script